import { Injectable } from '@angular/core';

@Injectable({
     providedIn: 'root'
})

export class TextService {
     
     constructor() { }

     public toTrim = (value: string | undefined) => {
          if (!value)
               return value;
          return value.trim();
     } 

     public toPascalCase = (value: string | undefined) => {
          return !value ? value : value
               .trim()
               .split(' ')
               .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
               .join(' ');
     }

     public toLowerCase = (value: string | undefined) => {
          return !value ? value : value.toLowerCase();
     }
}